import { FontAwesomeIconProps } from 'components/shared/icons/FontAwesomeIcon/FontAwesomeIcon.types';
import { muiStyles } from 'utils/design';

export const useStyles = muiStyles<FontAwesomeIconProps>((theme, { color }) => ({
  icon: {
    color: theme.palette[color as keyof typeof theme.palette]
      ? (theme.palette[color as keyof typeof theme.palette] as { main: string }).main
      : color,
  },
  fixedHeight: {
    height: '1.25rem',
    lineHeight: '1.25rem',
  },
}));
